import { render, staticRenderFns } from "./TransferirPosto.vue?vue&type=template&id=7495c7d5&"
import script from "./TransferirPosto.vue?vue&type=script&lang=js&"
export * from "./TransferirPosto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports